window.lightbox.option({
    maxWidth: 800,
    fadeDuration: 100,
    albumLabel: 'Imagen %1 de %2'
});